import baseRequest from './baseRequest';

const baseUrl = 'api/public/loan-officers';

// loIdentifier is the lo's email without TLD (e.g. harry@blend)
export const getLoanOfficer = async (loIdentifier: string): Promise<LOInformation> => {
  return (await baseRequest.get(`${baseUrl}/${loIdentifier}`)).data;
};
